import type { ComponentProps } from 'react'
import { cn } from '~/lib/utils'

export const SpaceSectionTitle = ({
	className,
	...props
}: ComponentProps<'div'>) => (
	<div
		{...props}
		className={cn('font-semibold text-2xl', className)}
	/>
)
